
export default {
	api:
	{
		url: 'https://api.nomepierdo.cl'
	}
};
